import { defineMessages, useIntl } from 'react-intl';
import { NoDataEmptyState } from '@carbon/ibm-products';
import cx from 'classnames';
import { ReactNode } from 'react';

import styles from './EmptyState.module.scss';

type Props = {
    title?: string
    className?: string;
    children?: ReactNode;
}

const EmptyState = ({
    title,
    className,
    children,
}: Props) => {
    const intl = useIntl();

    return (
        <div className={cx(styles.emptyStateContainer, className)}>
            <NoDataEmptyState
                illustrationDescription="Test alt text"
                subtitle={intl.formatMessage(messages.subtitle)}
                title={title || intl.formatMessage(messages.title)}
            />
            {children}
        </div>
    );
};

const messages = defineMessages({
    title: {
        id: 'emptyState.title',
        defaultMessage: 'Brak danych',
    },
    subtitle: {
        id: 'emptyState.subtitle',
        defaultMessage: 'Spróbuj dodać dane w odpowiedniej sekcji aplikacji.',
    },
});

export default EmptyState;
